module.exports = __webpack_public_path__ + "img/logoDarkHor.7ea73bbe.svg";